var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 350,
        width: 630,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "21",
          y: "0",
          rx: "3",
          ry: "3",
          width: "100",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "70",
          rx: "3",
          ry: "3",
          width: "588",
          height: "235",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "20",
          rx: "3",
          ry: "3",
          width: "240",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "50",
          rx: "1",
          ry: "1",
          width: "200",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "549",
          y: "50",
          rx: "1",
          ry: "1",
          width: "60",
          height: "15",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }